import { differenceInCalendarDays } from 'date-fns';
import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  data() {
    return {
      load        : false,
      showDialog  : false,
      softReads   : 0,
      viewData    : {},
      unsubscribe : null
    };
  },
  beforeMount() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === '_core/auth/SET_CURRENT_ROLE') {
        this.actionGetAllNotification();
      }
    });
  },
  mounted() {
    this.actionGetAllNotification();
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  computed: {
    ...mapGetters({
      notification   : '_core/notification/listNotification',
      shouldLoadMore : '_core/notification/shouldLoadMore',
      isImpersonated : '_core/auth/isImpersonated'
    }),
    ...mapState( {
      user: (state) => state._core.user
    }),
    hasUnreadElements() {
      return this.$store.state._core.notification.totalUnread - this.softReads > 0;
    }
  },
  methods: {
    ...mapActions({
      actionGetAllNotification       : '_core/notification/actionGetAllNotification',
      actionReadNotification         : '_core/notification/actionReadNotification',
      actionReadAllNotification      : '_core/notification/actionReadAllNotification',
      actionGetAllNotificationByPage : '_core/notification/actionGetAllNotificationByPage'
    }),
    async read(item, index) {
      if (!item.isRead && !item.softRead) {
        this.load = true;
        this.softReads += 1;
        item.softRead = true;
        this.actionReadNotification(item.recipientId);
        this.load = false;
      }

      if (item.recipientTargetUrl || item.notificationTargetUrl) {
        const url = item.recipientTargetUrl || item.notificationTargetUrl;

        if (url.startsWith('http')) {
          window.open(url);
        } else {
          this.$router.push(`${url}`);
        }
      } else {
        this.viewData = {
          title   : item.title,
          message : item.message,
          icon    : item.icon,
          sentAt  : item.sentAt
        };
        this.showDialog = true;
      }
    },
    async readAll() {
      this.load = true;
      await this.actionReadAllNotification();
      await this.actionGetAllNotification();
      this.load = false;
    },
    async onIntersect(entries, observer) {
      if (entries[0].isIntersecting && this.shouldLoadMore) {
        this.load = true;
        await this.actionGetAllNotificationByPage();
        this.load = false;
      }
    },
    isRead(item) {
      return item.isRead || item.softRead;
    },
    dateFormat(itemDate) {
      if (itemDate) {
        const currentDate = zonedTimeToUtc(new Date().toISOString(), this.user.timezone);
        const zonedDate = zonedTimeToUtc(itemDate, this.user.timezone);

        return this.$tc('_core.notifications.date',
          differenceInCalendarDays(currentDate, zonedDate),
          { d: formatInTimeZone(itemDate, 'UTC', 'dd/MM/yyyy'), t: formatInTimeZone(itemDate, 'UTC', 'HH:mm') }
        );
      }
    }
  }
};
